// Action Types
const SET_BOOK_DATA = "book/SET_BOOK_DATA";

// Action Creators
export const bookActions = {
	setBookData: (bookData) => ({ type: SET_BOOK_DATA, payload: bookData }),
};

// Initial State
export const getInitialBookState = () => ({
	title: "",
	permalink: "",
	chapters: [],
	verses: [],
	product: {
		image: "",
		price: "",
		title: "",
		link: "",
		content: "",
		author: "",
		translator: "",
	},
	pageType: "",
});

// Reducer
export const bookReducer = (state = getInitialBookState(), action) => {
	switch (action.type) {
	case SET_BOOK_DATA:
		return { ...state, ...action.payload };
	default:
		return state;
	}
};

// Selectors
export const bookSelectors = {
	getBookData: (state) => {
		return {
			title: state.book.title,
			permalink: state.book.permalink,
			slug: state.book.slug,
		};
	},
	getChapters: (state) => state.book.chapters,
	getVerses: (state) => state.book.verses,
	getProductData: (state) => state.book.product,
	getPageType: (state) => state.book.pageType,
};
